import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseGetByCabinetRequest, IBaseGetByComanyRequest, IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { ICreateSlotRequest, IGetSlotResponse, IUpdateSlotRequest } from '../models/slot';


@Injectable({
  providedIn: 'root'
})
export class SlotService {

  constructor(private http: HttpClient) { }

  // Slot
  createSlot(request: ICreateSlotRequest) {
    return this.http.post<IGetSlotResponse>(
      `${environment.baseUrl}/v1/slots/createSlot`,
      request
    )
  }

  getSlotsGlobal(request: IBaseSearchRequest){
    return this.http.post<IPagedResults<IGetSlotResponse[]>>(
      `${environment.baseUrl}/v1/slots/searchSlotsGlobal`,
      request
    )
  }

  getSlotsByCabinet(request: IBaseGetByCabinetRequest){
    return this.http.post<IPagedResults<IGetSlotResponse[]>>(
      `${environment.baseUrl}/v1/slots/searchSlotsByCabinet`,
      request
    )
  }

  getSlotById(id: string){
    return this.http.get<IGetSlotResponse>(
      `${environment.baseUrl}/v1/slots/getSlot/${id}`
    )
  }

  updateSlot(request: IUpdateSlotRequest){
    return this.http.put<IGetSlotResponse>(
      `${environment.baseUrl}/v1/slots/updateSlot/${request.id}`,
      request
    )
  }

  deleteSlot(id :string){
    return this.http.delete(
      `${environment.baseUrl}/v1/slots/deleteSlot/${id}`
    )
  }
}
